import React, { useRef } from 'react';
/**
 * @deprecated Renamed from VeltCommentDialogSuggestionAction* on 2026-07-20 to mirror the SDK's legacy rename
 * (velt-comment-dialog-legacy-suggestion-action*). Unreachable inside dialogs; kept for standalone usage.
 */
var VeltCommentDialogLegacySuggestionAction = function (props) {
    var annotationId = props.annotationId, defaultCondition = props.defaultCondition, inlineCommentSectionMode = props.inlineCommentSectionMode, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-dialog-legacy-suggestion-action", { ref: ref, "annotation-id": annotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "inline-comment-section-mode": [true, false].includes(inlineCommentSectionMode) ? (inlineCommentSectionMode ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentDialogLegacySuggestionAction;
